<template >
  <v-app class="back">
    <!-- LISTAGEM -->
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <v-col cols="12" sm="12" md="9" class="py-0">
          <v-row justify="start">
            <span class="display-1 titulo font-weight-bold">Associados</span>
            <v-spacer></v-spacer>
            <v-col cols="auto" sm="auto" md="auto" class="py-0 mt-1">
              <v-row no-gutters>
                <div
                  @click="filter_modal = true"
                  v-if="filtro.planos_nome.length > 0"
                  class="ml-2"
                >
                  <span style="font-size: 11px">Plano:</span>
                  <v-chip
                    small
                    class="ma-1"
                    v-for="(item, index) in filtro.planos_nome"
                    :key="index"
                    >{{ item }}</v-chip
                  >
                </div>
                <div
                  @click="filter_modal = true"
                  v-if="filtro.grupos_nome.length > 0"
                  class="ml-2"
                >
                  <span style="font-size: 11px">Grupo:</span>
                  <v-chip
                    small
                    v-for="(item, index) in filtro.grupos_nome"
                    :key="index"
                    class="ma-1"
                    >{{ item }}</v-chip
                  >
                </div>
                <div
                  @click="filter_modal = true"
                  v-if="filtro.classificacoes_nome.length > 0"
                  class="ml-2"
                >
                  <span style="font-size: 11px">Classificação:</span>
                  <v-chip
                    small
                    v-for="(item, index) in filtro.classificacoes_nome"
                    :key="index"
                    class="ma-1"
                    >{{ item }}</v-chip
                  >
                </div>
                <div
                  @click="filter_modal = true"
                  v-if="filtro.grupos_familiares_nome.length > 0"
                  class="ml-2"
                >
                  <span style="font-size: 11px">Grupo Familiar:</span>
                  <v-chip
                    small
                    v-for="(item, index) in filtro.grupos_familiares_nome"
                    :key="index"
                    class="ma-1"
                    >{{ item }}</v-chip
                  >
                </div>
              </v-row>
            </v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  outlined
                  @click="filter_modal = true"
                  class="mr-1"
                  v-on="on"
                >
                  <v-icon small color="#283480">mdi-filter</v-icon>
                </v-btn>
              </template>
              <span>Filtros</span>
            </v-tooltip>
            <v-col cols="12" sm="12" md="3" class="py-0">
              <v-text-field
                v-model="search"
                solo
                dense
                flat
                outlined
                placeholder="Buscar"
                append-icon="mdi-magnify"
                class="mb-n5"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="9">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhum associado cadastrado"
              hide-default-footer
              :headers="cabecalho"
              :items="formData"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
              :search="search"
              loading-text="Carregando itens..."
            >
              <template v-slot:item.usuario_imagem="{ item }">
                <v-avatar size="32" v-if="imgAWS(item)">
                  <img :src="getHashUser(item)" :lazy-src="getHashUser(item)" />
                </v-avatar>
                <v-avatar size="32" color="#283480" v-if="!item.usuario_imagem">
                  <span class="white--text headline text-uppercase">{{
                    item.usuario_nome.charAt(0)
                  }}</span>
                </v-avatar>
                <v-avatar size="32" v-else-if="!imgAWS(item)">
                  <img
                    :src="item.usuario_imagem"
                    :lazy-src="item.usuario_imagem"
                  />
                </v-avatar>
              </template>

              <template v-slot:item.fk_id_classificacao="{ item }">
                <v-chip
                  x-small
                  class
                  v-if="item.fk_id_classificacao"
                  v-text="idClassificacao(item)"
                ></v-chip>
                <span v-if="!item.fk_id_classificacao">-</span>
              </template>
              <template v-slot:item.usuario_nome="{ item }">
                <span>{{ item.usuario_nome }}</span>
                <span v-if="item.usuario_data_inativado" class="ml-1"
                  >(Desativado)</span
                >
              </template>
              <template
                v-slot:item.grupo_familiar.grupo_familiar_descricao="{ item }"
              >
                <v-chip
                  x-small
                  class
                  v-if="item.grupo_familiar"
                  v-text="item.grupo_familiar.grupo_familiar_descricao"
                ></v-chip>
                <span v-if="!item.fk_id_grupo_familiar">-</span>
              </template>
              <template v-slot:item.acao="{ item }">
                <v-menu offset-x>
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <!-- <div v-for="(iten, index) in opcoes" :key="index">
                      <v-list-item @click="menu(iten,item)">
                        <v-icon>{{ iten.icon }}</v-icon>
                        <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                      </v-list-item>
                    </div>-->
                    <v-list-item
                      @click="menu('⠀Editar', item)"
                      v-if="editModulo"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                      <v-list-item-title>⠀Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="menu('⠀Extrato', item)">
                      <v-icon>mdi-cash-multiple</v-icon>
                      <v-list-item-title>⠀Extrato</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="menu('⠀Excluir', item)"
                      v-if="editModulo"
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                      <v-list-item-title>⠀Excluir</v-list-item-title>
                    </v-list-item>
                    <div v-if="editModulo">
                      <v-list-item
                        @click="menu('⠀Inativar', item)"
                        v-if="!item.usuario_data_inativado"
                      >
                        <v-icon>mdi-arrow-down-thick</v-icon>
                        <v-list-item-title>⠀Desativar acesso</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="menu('⠀Ativar', item)" v-else>
                        <v-icon>mdi-arrow-up-thick</v-icon>
                        <v-list-item-title>⠀Ativar acesso</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:item.grupo_nome="{ item }">
                <v-chip x-small class v-if="item.grupo_nome">{{
                  item.grupo_nome
                }}</v-chip>
                <span v-if="!item.grupo_nome">-</span>
              </template>
              <template v-slot:item.plano_nome="{ item }">
                <v-chip x-small class v-if="item.plano_nome">{{
                  item.plano_nome
                }}</v-chip>
                <span v-if="!item.plano_nome">-</span>
              </template>
              <template v-slot:item.usuario_data_nascimento="{ item }">
                <span>{{ item.usuario_data_nascimento | moment("L") }}</span>
              </template>
              <template v-slot:footer>
                <v-row justify="center" class="mb-2">
                  <v-btn
                    v-if="items_per_pag > 10"
                    @click="items_per_pag -= 10"
                    text
                    color="#1F36C7"
                    >Mostrar menos</v-btn
                  >
                  <v-btn
                    v-if="formData.length > items_per_pag"
                    @click="carregarMais()"
                    text
                    color="#1F36C7"
                    >Carregar mais</v-btn
                  >
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda">
              <v-col class="mr-8" v-if="editModulo">
                <v-btn
                  @click="novoAssociado()"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480 !important"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1"
                    >mdi-account-multiple-plus</v-icon
                  >
                  <span class="white--text">Novo associado</span>
                </v-btn>
              </v-col>
              <v-col class="mr-8" v-if="editModulo">
                <v-btn
                  @click="dialog_mensagens = true"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480 !important"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1"
                    >mdi-email-outline</v-icon
                  >
                  <span class="white--text">Mensagens</span>
                </v-btn>
              </v-col>
              <div v-if="clube_hierarquia != 3">
                <v-col class="mr-8" v-if="editModulo">
                  <v-btn
                    @click="dialog_vincular = true"
                    large
                    rounded
                    block
                    class
                    style="background-color: #283480 !important"
                  >
                    <v-icon style="color: #00ffd4 !important" class="mr-1"
                      >mdi-file-tree</v-icon
                    >
                    <span class="white--text">Solicitar vínculo</span>
                  </v-btn>
                </v-col>
              </div>
              <div v-if="clube_hierarquia == 2 || clube_hierarquia == 3">
                <v-col class="mr-8" v-if="editModulo">
                  <v-btn
                    @click="dialog_vincular_associado = true"
                    large
                    rounded
                    block
                    class
                    style="background-color: #283480 !important"
                  >
                    <v-icon style="color: #00ffd4 !important" class="mr-1"
                      >mdi-file-tree</v-icon
                    >
                    <span class="white--text">Vincular Associado</span>
                  </v-btn>
                </v-col>
              </div>

              <div>
                <v-col class="mr-8">
                  <v-btn
                    large
                    rounded
                    block
                    style="background-color: #283480 !important"
                    @click="dialog_relatorio = true"
                  >
                    <v-icon class="agua mr-1">mdi-file-document-outline</v-icon>
                    <span class="white--text">Relatórios</span>
                  </v-btn>
                </v-col>
              </div>

              <v-col class="mr-8" v-if="clube_hierarquia != 1">
                <v-row justify="center">
                  <span class="font-weight-bold black--text"
                    >Meu código de associação:</span
                  >
                </v-row>
                <v-row justify="center">
                  <span class="font-weight-light">{{ cod_hierarquia }}</span>
                </v-row>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <div v-if="clube_hierarquia == 2">
        <v-row justify="start" class="my-4 ml-1">
          <!-- @click="getAssociados()" -->
          <span
            class="display-1 titulo font-weight-bold"
            @click="getAssociados()"
            >Clubes</span
          >
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="9">
            <v-card outlined class="borda" flat width="100%">
              <v-data-table
                no-data-text="Nenhum clube cadastrado"
                hide-default-footer
                :items="listagem"
                :headers="cabecalhoClubes"
                :items-per-page="items_per_pag2"
                class="elevation-0"
                :loading="loading"
                loading-text="Carregando itens..."
              >
                <template v-slot:item.clube_logotipo="{ item }">
                  <v-avatar size="32" v-if="item.clube_logotipo">
                    <img
                      :src="item.clube_logotipo"
                      :lazy-src="item.clube_logotipo"
                    />
                  </v-avatar>
                  <v-avatar
                    size="32"
                    color="#283480"
                    v-if="!item.clube_logotipo"
                  >
                    <!-- <span
                      class="white--text headline text-uppercase"
                    >{{item.clube_nome_comercial.charAt(0)}}</span>-->
                  </v-avatar>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at | moment("L") }}</span>
                </template>
                <template v-slot:item.plano="{ item }">
                  <v-chip x-small class v-if="item.plano_clube_nome">{{
                    item.plano_clube_nome
                  }}</v-chip>
                  <span v-if="!item.plano_clube_nome">-</span>
                </template>
                <template v-slot:item.hierarquia_requisicao_status="{ item }">
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 0"
                    >Pendente</v-chip
                  >
                  <v-chip
                    x-small
                    color="primary"
                    v-if="item.hierarquia_requisicao_status == 1"
                    >Vinculado</v-chip
                  >
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 2"
                    >Reprovado</v-chip
                  >
                </template>
                <template v-slot:item.acao="{ item }">
                  <v-tooltip top v-if="!editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon class="mr-1" v-on="on">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Sem autorização para
                      <span class="orange--text">editar</span>
                    </span>
                  </v-tooltip>
                  <v-menu offset-x v-if="editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon text v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div v-for="(iten, index) in opcoes2" :key="index">
                        <v-list-item @click="menu_status(iten, item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:footer>
                  <v-row justify="center" class="mb-2">
                    <v-btn
                      v-if="items_per_pag2 > 10"
                      @click="items_per_pag2 -= 10"
                      text
                      color="#1F36C7"
                      >Mostrar menos</v-btn
                    >
                    <v-btn
                      v-if="listagem.length > items_per_pag2"
                      @click="carregarMais2()"
                      text
                      color="#1F36C7"
                      >Carregar mais</v-btn
                    >
                  </v-row>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- Table distrito qnd é clube -->
      <div v-if="clube_hierarquia == 1">
        <v-row justify="start" class="my-4 ml-1">
          <span class="display-1 titulo font-weight-bold">Distrito</span>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="9">
            <v-card outlined class="borda" flat width="100%">
              <v-data-table
                no-data-text="Nenhum clube cadastrado"
                hide-default-footer
                :items="listagem"
                :headers="cabecalhoClubesAbaixo"
                :items-per-page="items_per_pag3"
                class="elevation-0"
                :loading="loading"
                loading-text="Carregando itens..."
              >
                <template v-slot:item.clube_logotipo="{ item }">
                  <v-avatar size="32" v-if="item.clube_logotipo">
                    <img
                      :src="item.clube_logotipo"
                      :lazy-src="item.clube_logotipo"
                    />
                  </v-avatar>
                  <v-avatar
                    size="32"
                    color="#283480"
                    v-if="!item.clube_logotipo"
                  >
                    <span class="white--text headline text-uppercase">{{
                      item.clube_nome_comercial.charAt(0)
                    }}</span>
                  </v-avatar>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at | moment("L") }}</span>
                </template>
                <template v-slot:item.hierarquia_requisicao_status="{ item }">
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 0"
                    >Pendente</v-chip
                  >
                  <v-chip
                    x-small
                    color="primary"
                    v-if="item.hierarquia_requisicao_status == 1"
                    >Vinculado</v-chip
                  >
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 2"
                    >Reprovado</v-chip
                  >
                </template>
                <template v-slot:item.acao="{ item }">
                  <v-tooltip top v-if="!editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon class="mr-1" v-on="on">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Sem autorização para
                      <span class="orange--text">editar</span>
                    </span>
                  </v-tooltip>
                  <v-menu offset-x v-if="editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon text v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div v-for="(iten, index) in opcoesCancelar" :key="index">
                        <v-list-item @click="menu_status(iten, item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:footer>
                  <v-row justify="center" class="mb-2">
                    <v-btn
                      v-if="items_per_pag3 > 10"
                      @click="items_per_pag3 -= 10"
                      text
                      color="#1F36C7"
                      >Mostrar menos</v-btn
                    >
                    <v-btn
                      v-if="listagem.length > items_per_pag3"
                      @click="carregarMais3()"
                      text
                      color="#1F36C7"
                      >Carregar mais</v-btn
                    >
                  </v-row>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- Table distrito qnd é DM -->
      <div v-if="clube_hierarquia == 3">
        <v-row justify="start" class="my-4 ml-1">
          <span class="display-1 titulo font-weight-bold">Distrito</span>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="9">
            <v-card outlined class="borda" flat width="100%">
              <v-data-table
                no-data-text="Nenhum clube cadastrado"
                hide-default-footer
                :items="listagem"
                :headers="cabecalhoClubes"
                :items-per-page="items_per_pag4"
                class="elevation-0"
                :loading="loading"
                loading-text="Carregando itens..."
              >
                <template v-slot:item.clube_logotipo="{ item }">
                  <v-avatar size="32" v-if="item.clube_logotipo">
                    <img
                      :src="item.clube_logotipo"
                      :lazy-src="item.clube_logotipo"
                    />
                  </v-avatar>
                  <v-avatar
                    size="32"
                    color="#283480"
                    v-if="!item.clube_logotipo"
                  >
                    <span class="white--text headline text-uppercase">{{
                      item.clube_nome_comercial.charAt(0)
                    }}</span>
                  </v-avatar>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at | moment("L") }}</span>
                </template>
                <template v-slot:item.plano="{ item }">
                  <v-chip x-small class v-if="item.plano_clube_nome">{{
                    item.plano_clube_nome
                  }}</v-chip>
                  <span v-if="!item.plano_clube_nome">-</span>
                </template>
                <template v-slot:item.hierarquia_requisicao_status="{ item }">
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 0"
                    >Pendente</v-chip
                  >
                  <v-chip
                    x-small
                    color="primary"
                    v-if="item.hierarquia_requisicao_status == 1"
                    >Vinculado</v-chip
                  >
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 2"
                    >Reprovado</v-chip
                  >
                </template>
                <template v-slot:item.acao="{ item }">
                  <v-tooltip top v-if="!editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        @click="filter_modal = true"
                        class="mr-1"
                        v-on="on"
                      >
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Sem autorização para
                      <span class="orange--text">editar</span>
                    </span>
                  </v-tooltip>
                  <v-menu offset-x v-if="editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon text v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div v-for="(iten, index) in opcoes2" :key="index">
                        <v-list-item @click="menu_status(iten, item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:footer>
                  <v-row justify="center" class="mb-2">
                    <v-btn
                      v-if="items_per_pag4 > 10"
                      @click="items_per_pag4 -= 10"
                      text
                      color="#1F36C7"
                      >Mostrar menos</v-btn
                    >
                    <v-btn
                      v-if="listagem.length > items_per_pag4"
                      @click="carregarMais4()"
                      text
                      color="#1F36C7"
                      >Carregar mais</v-btn
                    >
                  </v-row>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="clube_hierarquia == 2">
        <v-row justify="start" class="my-4 ml-1">
          <span class="display-1 titulo font-weight-bold"
            >Distrito Múltiplo</span
          >
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="9">
            <v-card outlined class="borda" flat width="100%">
              <v-data-table
                no-data-text="Nenhum distrito múltiplo cadastrado"
                hide-default-footer
                :items="listagemDm"
                :headers="cabecalhoDistritoM"
                :items-per-page="items_per_pag5"
                class="elevation-0"
                :loading="loading"
                loading-text="Carregando itens..."
              >
                <template v-slot:item.clube_logotipo="{ item }">
                  <v-avatar size="32" v-if="item.clube_logotipo">
                    <img
                      :src="item.clube_logotipo"
                      :lazy-src="item.clube_logotipo"
                    />
                  </v-avatar>
                  <v-avatar
                    size="32"
                    color="#283480"
                    v-if="!item.clube_logotipo"
                  >
                    <span class="white--text headline text-uppercase">{{
                      item.clube_nome_comercial.charAt(0)
                    }}</span>
                  </v-avatar>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at | moment("L") }}</span>
                </template>
                <template v-slot:item.hierarquia_requisicao_status="{ item }">
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 0"
                    >Pendente</v-chip
                  >
                  <v-chip
                    x-small
                    color="primary"
                    v-if="item.hierarquia_requisicao_status == 1"
                    >Vinculado</v-chip
                  >
                  <v-chip x-small v-if="item.hierarquia_requisicao_status == 2"
                    >Reprovado</v-chip
                  >
                </template>
                <template v-slot:item.acao="{ item }">
                  <v-tooltip top v-if="!editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        @click="filter_modal = true"
                        class="mr-1"
                        v-on="on"
                      >
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Sem autorização para
                      <span class="orange--text">editar</span>
                    </span>
                  </v-tooltip>
                  <v-menu offset-x v-if="editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon text v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div v-for="(iten, index) in opcoesRemover" :key="index">
                        <v-list-item @click="menu_status(iten, item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:footer>
                  <v-row justify="center" class="mb-2">
                    <v-btn
                      v-if="items_per_pag5 > 10"
                      @click="items_per_pag5 -= 10"
                      text
                      color="#1F36C7"
                      >Mostrar menos</v-btn
                    >
                    <v-btn
                      v-if="listagemDm.length > items_per_pag5"
                      @click="carregarMais5()"
                      text
                      color="#1F36C7"
                      >Carregar mais</v-btn
                    >
                  </v-row>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <!-- DIALOG CADASTRAR -->
    <v-dialog v-model="dialog_associado" scrollable persistent width="900px">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            <span v-if="novo_associado.id_usuario"
              >Editar associado - {{ novo_associado.usuario_id }}</span
            >
            <span v-else>Novo associado</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="7" md="7" class="mb-n5">
                <span class="font-weight-bold black--text">Nome *</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="novo_associado.usuario_nome"
                  solo
                  dense
                  flat
                  outlined
                  :autofocus="true"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="1"
                md="1"
                class="px-0 py-6"
                v-if="novo_associado.id_usuario"
              >
                <v-avatar size="32" v-if="novo_associado.usuario_imagem">
                  <img
                    :src="novo_associado.usuario_imagem"
                    :alt="novo_associado.usuario_imagem"
                  />
                </v-avatar>
                <v-avatar
                  size="32"
                  color="#283480"
                  v-if="!novo_associado.usuario_imagem"
                >
                  <span class="white--text headline text-uppercase">{{
                    novo_associado.usuario_nome.charAt(0)
                  }}</span>
                </v-avatar>
                <v-icon
                  small
                  @click="
                    (novo_associado.usuario_imagem_delete = 1),
                      (novo_associado.usuario_imagem = '')
                  "
                  v-if="novo_associado.usuario_imagem"
                  >mdi-delete-outline</v-icon
                >
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Imagem</span>
                <v-file-input
                  prepend-icon="mdi-camera"
                  solo
                  v-model="novo_associado.usuario_imagem"
                  outlined
                  accept="image/jpg, image/png, image/jpeg"
                  flat
                  dense
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Grupo *</span>
                <v-select
                  label="Selecione"
                  no-data-text="Sem grupo cadastrado"
                  :rules="requiredRules"
                  v-model="novo_associado.grupo"
                  solo
                  dense
                  flat
                  outlined
                  :items="grupos"
                  item-value="value"
                  item-text="text"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Perfil *</span>
                <v-select
                  label="Selecione"
                  no-data-text="Sem perfil cadastrado"
                  :rules="requiredRules"
                  v-model="novo_associado.fk_id_perfil"
                  solo
                  dense
                  flat
                  outlined
                  :items="perfil"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Plano</span>
                <v-select
                  label="Selecione"
                  no-data-text="Nenhum registro encontrado"
                  v-model="novo_associado.plano"
                  solo
                  dense
                  flat
                  outlined
                  clearable
                  :items="planos"
                  @change="changePlano()"
                  item-value="id_plano_clube"
                  item-text="plano_clube_nome"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="8" class="mb-n5">
                <span class="font-weight-bold black--text">Email *</span>
                <v-text-field
                  :rules="rulesAdicionalEmail"
                  v-model="novo_associado.usuario_email"
                  solo
                  type="email"
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Senha</span>
                <v-text-field
                  v-model="novo_associado.usuario_senha"
                  @click:append="ver_senha()"
                  :type="senha"
                  :append-icon="senha_icone"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text"
                  >Data de Nascimento</span
                >
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="
                        novo_associado.usuario_data_nascimento =
                          parseDate(dateFormatted)
                      "
                      v-model="dateFormatted"
                      append-icon="mdi-calendar"
                      clearable
                      v-mask="data_mask"
                      v-on="on"
                      @input="menu1 = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    ref="picker"
                    locale="pt-br"
                    scrollable
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  CPF
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  v-mask="cpf"
                  v-model="novo_associado.usuario_cpf"
                  solo
                  @input="verificar_cpf()"
                  dense
                  flat
                  outlined
                  :rules="rulesAdicionalCPF"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Telefone
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  v-model="novo_associado.usuario_telefone"
                  solo
                  v-mask="telefone"
                  dense
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <v-row class="ma-0 pa-0">
                  <v-col md="auto" class="ma-0 pa-0">
                    <span class="font-weight-bold black--text">
                      CEP
                      <span v-if="requiredAdicional">*</span>
                    </span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col md="auto" class="ma-0 pa-0">
                    <span v-if="cep_errado" class="red--text">{{
                      cep_errado
                    }}</span>
                  </v-col>
                </v-row>
                <v-text-field
                  v-model="novo_associado.usuario_cep"
                  solo
                  @blur="viaCep"
                  dense
                  v-mask="cep"
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="8" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Rua
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  v-model="novo_associado.usuario_rua"
                  solo
                  dense
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Número
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  v-model.number="novo_associado.usuario_numero"
                  solo
                  dense
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Complemento</span>
                <v-text-field
                  v-model="novo_associado.usuario_complemento"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Bairro
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  v-model="novo_associado.usuario_bairro"
                  solo
                  dense
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  País
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-autocomplete
                  v-model="novo_associado.usuario_pais"
                  solo
                  dense
                  label="Selecione"
                  :items="paises"
                  :disabled="disable_locais"
                  no-data-text="Não encontrado"
                  flat
                  @input="getEstados()"
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-autocomplete>
              </v-col>
              <v-col
                v-if="brazil == true"
                cols="12"
                sm="4"
                md="4"
                class="mb-n5"
              >
                <span class="font-weight-bold black--text">
                  Estado
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-autocomplete
                  v-model="novo_associado.usuario_estado"
                  solo
                  dense
                  :items="estados"
                  label="Selecione"
                  no-data-text="Não encontrado"
                  flat
                  outlined
                  @input="getCidades()"
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-autocomplete>
              </v-col>
              <v-col v-else cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Estado
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  :disabled="disable_locais"
                  v-model="novo_associado.usuario_estado"
                  solo
                  dense
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="brazil == true"
                cols="12"
                sm="4"
                md="4"
                class="mb-n5"
              >
                <span class="font-weight-bold black--text">
                  Cidade
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-autocomplete
                  v-model="novo_associado.usuario_cidade"
                  no-data-text="Não encontrado"
                  solo
                  dense
                  :items="cidades"
                  label="Selecione"
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-autocomplete>
              </v-col>
              <v-col v-else cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Cidade
                  <span v-if="requiredAdicional">*</span>
                </span>
                <v-text-field
                  :disabled="disable_locais"
                  v-model="novo_associado.usuario_cidade"
                  solo
                  dense
                  flat
                  outlined
                  :rules="rulesAdicional"
                  :required="requiredAdicional"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text"
                  >Código de Controle</span
                >
                <v-text-field
                  v-model="novo_associado.codigo_controle"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Classificação</span>
                <v-select
                  label="Selecione"
                  no-data-text="Nenhuma classificação cadastrada"
                  v-model="novo_associado.fk_id_classificacao"
                  solo
                  dense
                  flat
                  outlined
                  clearable
                  :items="classificacoes"
                  item-value="id_classificacao"
                  item-text="classificacao_descricao"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Grupo Familiar</span>
                <v-select
                  label="Selecione"
                  no-data-text="Nenhum grupo familiar cadastrado"
                  v-model="novo_associado.fk_id_grupo_familiar"
                  solo
                  dense
                  flat
                  outlined
                  clearable
                  :items="grupos_familiares"
                  item-value="id_grupo_familiar"
                  item-text="grupo_familiar_descricao"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mb-n5">
                <span class="font-weight-bold black--text"
                  >Data de Associação</span
                >
                <v-menu
                  v-model="menuAssociado"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="
                        novo_associado.usuario_data_associacao = parseDate(
                          dateFormattedAssociado
                        )
                      "
                      v-model="dateFormattedAssociado"
                      append-icon="mdi-calendar"
                      clearable
                      v-mask="data_mask"
                      v-on="on"
                      @input="menuAssociado = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateAssociado"
                    no-title
                    ref="picker"
                    locale="pt-br"
                    scrollable
                    @input="menuAssociado = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="font-weight-bold black--text">Observação</span>
                <v-textarea
                  auto-grow
                  v-model="novo_associado.usuario_observacao"
                  outlined
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                style="color: #283480 !important"
                outlined
                >Cancelar</v-btn
              >
              <v-btn
                class="ml-2"
                rounded
                :loading="loading"
                :disabled="loading"
                style="
                  background-color: #283480 !important;
                  color: #00ffd4 !important;
                "
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG NOVO EXTRATO -->
    <v-dialog persistent v-model="dialog_novo_extrato" max-width="600">
      <v-form ref="form" v-model="valid" @submit.prevent="postExtrato()">
        <v-card flat class="borda">
          <v-card-title>
            <span v-if="!novo_extrato.id_extrato">Novo Lançamento</span>
            <span v-else>Editar Lançamento</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close_extrato()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row class="mt-n6">
              <v-col md="6">
                <span class="font-weight-bold black--text">Tipo *</span>
                <v-select
                  label="Selecione"
                  :rules="requiredRules"
                  v-model="novo_extrato.tipo"
                  solo
                  dense
                  @change="fluxo1()"
                  flat
                  :disabled="!!novo_extrato.id_extrato"
                  outlined
                  :items="extrato_tipo"
                ></v-select>
              </v-col>
              <v-col md="6">
                <span class="font-weight-bold black--text">Lançamento *</span>
                <v-menu
                  ref="menuExtratoLancamento"
                  v-model="menuExtratoLancamento"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="
                        novo_extrato.lancamento = parseDate(
                          dateFormattedExtratoL
                        )
                      "
                      v-model="dateFormattedExtratoL"
                      append-icon="mdi-calendar"
                      :rules="requiredRules"
                      clearable
                      v-mask="data_mask"
                      v-on="on"
                      @input="menuExtratoLancamento = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExtratoL"
                    no-title
                    :min="fechamento_data"
                    ref="picker"
                    locale="pt-br"
                    scrollable
                    @input="menuExtratoLancamento = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="mt-n6">
              <v-col md="6">
                <span class="font-weight-bold black--text">Vencimento *</span>
                <v-menu
                  ref="menuExtrato"
                  v-model="menuExtrato"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="
                        novo_extrato.vencimento =
                          parseDate(dateFormattedExtrato)
                      "
                      v-model="dateFormattedExtrato"
                      append-icon="mdi-calendar"
                      :rules="requiredRules"
                      clearable
                      v-mask="data_mask"
                      v-on="on"
                      @input="menuExtrato = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExtrato"
                    no-title
                    ref="picker"
                    locale="pt-br"
                    scrollable
                    @input="menuExtrato = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <span class="font-weight-bold black--text">Valor *</span>
                <input
                  class="input"
                  :rules="requiredRules"
                  v-model.lazy="novo_extrato.valor_bruto"
                  v-money="moneyFormat"
                />
              </v-col>
            </v-row>
            <v-row class="mt-n6">
              <v-col>
                <span class="font-weight-bold black--text">Descrição *</span>
                <v-textarea
                  auto-grow
                  :rules="requiredRules"
                  v-model="novo_extrato.descricao"
                  outlined
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
            <div v-if="!novo_extrato.id_extrato">
              <v-row class="mt-n8">
                <v-col v-if="novo_extrato.tipo == 1" class="mb-n8">
                  <v-checkbox
                    class="pa-0 ma-0"
                    color="#283480"
                    label="Cobrança Online"
                    v-model="novo_extrato.asaas_bol"
                  ></v-checkbox>
                </v-col>
                <v-col class="mb-n8">
                  <v-checkbox
                    class="pa-0 ma-0"
                    color="#283480"
                    label="Criar Fluxo"
                    v-model="novo_extrato.fluxo_bol"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-bold black--text">
                    Conta
                    <span
                      v-if="novo_extrato.fluxo_bol"
                      class="font-weight-bold black--text"
                      >*</span
                    >
                  </span>

                  <v-select
                    label="Selecione"
                    :rules="requiredFluxo"
                    v-model="novo_extrato.conta"
                    solo
                    dense
                    flat
                    clearable
                    outlined
                    :items="contas"
                  ></v-select>
                </v-col>
                <v-col>
                  <span class="font-weight-bold black--text">
                    Categoria
                    <span
                      v-if="novo_extrato.fluxo_bol"
                      class="font-weight-bold black--text"
                      >*</span
                    >
                  </span>
                  <v-select
                    label="Selecione"
                    :rules="requiredFluxo"
                    v-model="novo_extrato.categoria"
                    solo
                    dense
                    clearable
                    flat
                    outlined
                    :items="categorias"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row class="mt-n6">
                <v-col>
                  <span class="font-weight-bold black--text">Status</span>
                  <v-select
                    label="Selecione"
                    v-model="novo_extrato.extrato_status"
                    solo
                    dense
                    flat
                    outlined
                    :items="opcoesStatus"
                  ></v-select>
                </v-col>
                <v-col>
                  <span class="font-weight-bold black--text">Conta</span>
                  <v-select
                    label="Selecione"
                    v-model="novo_extrato.conta"
                    solo
                    dense
                    flat
                    outlined
                    :items="contas"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions class="mt-n4">
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close_extrato()"
                rounded
                style="color: #283480 !important"
                :disabled="loadingExtrato"
                outlined
                >Cancelar</v-btn
              >
              <v-btn
                class="ml-2"
                rounded
                :loading="loadingExtrato"
                :disabled="loadingExtrato"
                style="
                  background-color: #283480 !important;
                  color: #00ffd4 !important;
                "
                @click="postExtrato()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- this.dialog_extrato = true; -->
    <v-dialog v-model="dialog_extrato" scrollable persistent width="900px">
      <v-form ref="form3" v-model="valid">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Extrato Financeiro
            <v-spacer></v-spacer>

            <v-chip @click="dialog_filtro = true" x-medium class="ma-1 mr-2"
              >Período: {{ filtroExtrato.start | moment("L") }} a
              {{ filtroExtrato.end | moment("L") }}</v-chip
            >
            <!-- v-if="filtroExtrato.start != ''" -->

            <v-btn icon text class="mr-1" @click="dialog_filtro = true">
              <v-icon>mdi-filter-outline</v-icon>
            </v-btn>
            <v-btn
              rounded
              color="#283480"
              @click="dialog_novo_extrato = true"
              class="white--text mr-1"
              >Novo Lançamento</v-btn
            >
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-card outlined class="borda">
              <v-data-table
                no-data-text="Nenhum extrado cadastrado"
                hide-default-footer
                :headers="cabecalhoExtrato"
                :items="extratos"
                :items-per-page="items_per_pag6"
                class="elevation-0"
                :loading="loadingLancamentos"
                loading-text="Carregando itens..."
              >
                <template v-slot:item.extrato_status="{ item }">
                  <v-icon
                    small
                    color="#1976d2"
                    class="mr-1"
                    title="Confirmado"
                    v-if="item.extrato_status == 1"
                    >mdi-check</v-icon
                  >
                  <v-icon
                    small
                    color="#ccc"
                    class="mr-1"
                    title="Não confirmado"
                    v-if="item.extrato_status == 0"
                    >mdi-check</v-icon
                  >
                  <v-icon
                    small
                    color="#4caf50"
                    class="mr-1"
                    title="Conciliado"
                    v-if="item.extrato_status == 2"
                    >mdi-check-all</v-icon
                  >
                </template>
                <template v-slot:item.conta_nome="{ item }">
                  <span v-if="item.conta_nome">{{ item.conta_nome }}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.extrato_lancamento="{ item }">
                  <!-- Data -->
                  <span v-if="item.extrato_lancamento">{{
                    item.extrato_lancamento | moment("L")
                  }}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.extrato_vencimento="{ item }">
                  <span>{{ item.extrato_vencimento | moment("L") }}</span>
                </template>
                <template v-slot:item.extrato_cred="{ item }">
                  <span v-if="item.extrato_tipo == 1">{{
                    floatToMoney2(item.extrato_valor)
                  }}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.extrato_deb="{ item }">
                  <span v-if="item.extrato_tipo == 2">{{
                    floatToMoney2(item.extrato_valor)
                  }}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.acoes="{ item }" v-if="editModulo">
                  <v-btn icon @click="acaoExtrato('Editar', item)">
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn icon @click="acaoExtrato('Excluir', item)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <template v-slot:footer>
                  <v-row justify="center" class="mb-2">
                    <v-btn
                      v-if="items_per_pag6 > 10"
                      @click="items_per_pag6 -= 10"
                      text
                      color="#1F36C7"
                      >Mostrar menos</v-btn
                    >
                    <v-btn
                      v-if="extratos.length > items_per_pag6"
                      @click="carregarMais6()"
                      text
                      color="#1F36C7"
                      >Carregar mais</v-btn
                    >
                  </v-row>
                  <v-row justify="end" no-gutters>
                    <strong class="mr-1">Saldo Anterior:</strong>
                    <strong
                      v-bind:class="{
                        'verde2 mr-1': extratoValores.saldo_anterior > 0,
                        'vermelho2 mr-1': extratoValores.saldo_anterior < 0,
                        'mr-1': extratoValores.saldo_anterior == 0,
                      }"
                      v-text="saldoExtrato('1')"
                    ></strong>
                  </v-row>
                  <v-row justify="end" no-gutters>
                    <strong class="mr-1">Saldo período:</strong>
                    <strong
                      v-bind:class="{
                        'verde2 mr-1': extratoValores.saldo_periodo > 0,
                        'vermelho2 mr-1': extratoValores.saldo_periodo < 0,
                        'mr-1': extratoValores.saldo_periodo == 0,
                      }"
                      v-text="saldoExtrato('2')"
                    ></strong>
                  </v-row>
                  <v-row justify="end" no-gutters>
                    <strong class="mr-1">Saldo conciliado no período:</strong>
                    <strong
                      v-bind:class="{
                        'verde2 mr-1': extratoValores.saldo_conciliado > 0,
                        'vermelho2 mr-1': extratoValores.saldo_conciliado < 0,
                        'mr-1': extratoValores.saldo_conciliado == 0,
                      }"
                      v-text="saldoExtrato('3')"
                    ></strong>
                  </v-row>
                  <v-row justify="end" no-gutters>
                    <strong class="mr-1">Saldo provisionado:</strong>
                    <strong
                      v-bind:class="{
                        'verde2 mr-1': extratoValores.saldo_provisionado > 0,
                        'vermelho2 mr-1': extratoValores.saldo_provisionado < 0,
                        'mr-1': extratoValores.saldo_provisionado == 0,
                      }"
                      v-text="saldoExtrato('4')"
                    ></strong>
                  </v-row>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                style="color: #283480 !important"
                outlined
                >Fechar</v-btn
              >
              <!-- <v-btn
                class="ml-2"
                rounded
                :loading="loading"
                :disabled="loading"
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="edit()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>-->
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG DELETAR -->
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline"
          >Tem certeza que deseja deletar esta conta?</v-card-title
        >
        <v-card-text
          >Se deletar esta conta ela não poderá ser recuperada!!</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false"
            >Cancelar</v-btn
          >
          <v-btn
            style="
              background-color: #283480 !important;
              color: #00ffd4 !important;
            "
            rounded
            @click="deleteItem(), (dialog_delete = false)"
            >Sim, tenho certeza</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG MENSAGENS -->
    <v-form ref="formMsg" v-model="valid" @submit.prevent="mensagens()">
      <v-dialog
        v-model="dialog_mensagens"
        scrollable
        max-width="700px"
        transition="dialog-transition"
      >
        <v-card class="borda" flat>
          <v-card-title class="ma-2">
            Enviar Mensagem
            <v-spacer></v-spacer>
            <v-btn icon text @click="close_msg()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>
              <v-col
                md="6"
                sm="6"
                cols="12"
                v-if="!nova_mensagem.enviar_grupos"
              >
                <v-switch
                  color="#283480"
                  @change="changeAssociados()"
                  v-model="nova_mensagem.enviar_todos_associados"
                  label="Enviar para todos os associados"
                ></v-switch>
              </v-col>
              <v-col
                md="6"
                sm="6"
                cols="12"
                v-if="!nova_mensagem.enviar_todos_associados"
              >
                <v-switch
                  color="#283480"
                  @change="changeGrupos()"
                  v-model="nova_mensagem.enviar_grupos"
                  label="Enviar para grupos"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row class="mt-n6">
              <v-col md="12">
                <v-checkbox
                  v-model="nova_mensagem.enviar_email"
                  color="#283480"
                  label="Enviar email"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="mt-n6" v-if="nova_mensagem.enviar_grupos">
              <v-col>
                <span class="font-weight-bold black--text"
                  >Selecione os grupos:</span
                >
                <v-autocomplete
                  v-model="nova_mensagem.grupos"
                  :items="msgToGrupos"
                  outlined
                  item-color="#283480"
                  dense
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ nova_mensagem.grupos.length - 1 }} outros)</span
                    >
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row
              class="mt-n6"
              v-if="
                !nova_mensagem.enviar_todos_associados &&
                !nova_mensagem.enviar_grupos
              "
            >
              <v-col>
                <span class="font-weight-bold black--text"
                  >Selecione os associados:</span
                >
                <v-autocomplete
                  v-model="nova_mensagem.usuarios"
                  :items="msgTo"
                  outlined
                  item-color="#283480"
                  dense
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ nova_mensagem.usuarios.length - 1 }} outros)</span
                    >
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="mt-n6">
              <v-col>
                <span class="font-weight-bold black--text">Título: *</span>
                <v-text-field
                  solo
                  flat
                  :rules="requiredRules"
                  outlined
                  v-model="nova_mensagem.mensagem_titulo"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-n6">
              <v-col>
                <span class="font-weight-bold black--text">Assunto *</span>
                <vue-editor
                  key="1"
                  class="tooltipDescricao"
                  v-model="nova_mensagem.mensagem_descricao"
                  :editorToolbar="editor.customToolbar"
                ></vue-editor>
                <v-text-field
                  style="display: none"
                  :rules="requiredRules"
                  v-model="nova_mensagem.mensagem_descricao"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn
                outlined
                rounded
                :disabled="loadingMsg"
                class="mr-2"
                color="#283480"
                @click="close_msg()"
                >Cancelar</v-btn
              >
              <v-btn
                style="
                  background-color: #283480 !important;
                  color: #00ffd4 !important;
                "
                rounded
                :loading="loadingMsg"
                :disabled="loadingMsg"
                @click="ctzMsg()"
                >Enviar Mensagem</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ctz_msg" persistent max-width="550">
        <v-card class="borda" flat>
          <v-card-title class="headline">Ação Irreversível</v-card-title>
          <v-card-text style="text-align: justify; text-justify: inter-word"
            >Ao enviar esta Mensagem não poderá excluir ou editar, tens certeza
            que deseja enviar a Mensagem?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              :disabled="loadingMsg"
              rounded
              color="#283480"
              @click="dialog_ctz_msg = false"
              >Cancelar</v-btn
            >
            <v-btn
              style="
                background-color: #283480 !important;
                color: #00ffd4 !important;
              "
              rounded
              :loading="loadingMsg"
              :disabled="loadingMsg"
              @click="mensagens()"
              >Sim, tenho certeza</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <!-- DIALOG VINCULO -->
    <v-dialog
      v-model="dialog_vincular"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-form ref="formCod" v-model="valid" @submit.prevent="validar_codigo()">
        <v-card class="borda" flat>
          <v-card-title class="ma-2">
            Solicitar vínculo
            <v-spacer></v-spacer>
            <v-btn icon text @click="close_vincular()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>
              <v-col justify="center">
                <span class="font-weight-bold black--text"
                  >Digite o código de associação: *</span
                >
                <v-text-field
                  solo
                  flat
                  :rules="rulesAdicionalCod"
                  outlined
                  v-model="codigo_hierarquia"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-n8">
                <v-btn
                  @click="validar_codigo"
                  rounded
                  :loading="loading_vinculo"
                  :disabled="loading_vinculo"
                  color="#283480"
                  class="white--text mb-1"
                  >Válidar código</v-btn
                >
              </v-col>
            </v-row>
            <div v-if="valido">
              <v-divider></v-divider>
              <v-row justify="center" class="mt-3">
                <span class="subtitle-1 black--text font-height-light">
                  Foi encontrado o clube
                  <strong>{{ clube_codigo.clube_nome_comercial }}</strong
                  >, deseja solicitar vínculo?
                </span>
              </v-row>
              <v-row justify="center">
                <v-btn
                  rounded
                  outlined
                  color="#283480"
                  class="mr-2"
                  @click="close_vincular()"
                  >Não</v-btn
                >
                <v-btn
                  color="#283480"
                  :loading="loading_sim"
                  :disabled="loading_sim"
                  @click="confirmar_vinculo"
                  rounded
                  class="white--text ml-2"
                  >Sim</v-btn
                >
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG VINCULAR ASSOCIADO -->
    <v-dialog
      v-model="dialog_vincular_associado"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-form
        ref="formCodAssociado"
        v-model="valid"
        @submit.prevent="saveVinculoAssociado()"
      >
        <v-card class="borda" flat>
          <v-card-title class="ma-2">
            Vincular associado
            <v-spacer></v-spacer>
            <v-btn icon text @click="close_vincular()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>
              <v-col justify="center">
                <span class="font-weight-bold black--text"
                  >Digite o código do associado: *</span
                >
                <v-text-field
                  solo
                  flat
                  required
                  :rules="requiredRules"
                  outlined
                  v-model="codigo_associado"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined rounded color="#283480" @click="close_vincular()"
              >Cancelar</v-btn
            >
            <v-btn
              style="
                background-color: #283480 !important;
                color: #00ffd4 !important;
              "
              rounded
              :loading="loadingVincularAssociado"
              :disabled="loadingVincularAssociado"
              type="submit"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG STATUS -->
    <v-dialog
      v-model="dialog_status"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="borda" flat>
        <v-card-text>
          <v-row>
            <v-col md="10">
              <span class="black--text subtitle-1">
                Deseja aceitar o vínculo de
                <strong>{{ nome_comercial }}</strong
                >?
              </span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="auto">
              <v-btn icon text @click="dialog_status = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn
              rounded
              outlined
              @click="setStatus(2)"
              color="#283480"
              class="mr-2"
              >Recusar vínculo</v-btn
            >
            <v-btn
              color="#283480"
              @click="setStatus(1)"
              :loading="loading_sim"
              :disabled="loading_sim"
              rounded
              class="white--text ml-2"
              >Aceitar vínculo</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG REMOVER -->
    <v-dialog
      v-model="dialog_remover"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="borda" flat>
        <v-card-text>
          <v-row>
            <v-col md="auto">
              <span class="black--text subtitle-1">
                <span class="title"
                  >Tem certeza que deseja encerrar vinculo?</span
                >
                <br />Esta ação será
                <Strong>irreversível</Strong>
              </span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="auto">
              <v-btn icon text @click="dialog_remover = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn
              rounded
              outlined
              color="#283480"
              class="mr-2"
              @click="dialog_remover = false"
              >Não</v-btn
            >
            <v-btn
              color="#283480"
              @click="deleteVinculo()"
              rounded
              class="white--text ml-2"
              >Sim</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG INATIVAR -->
    <v-dialog v-model="dialog_inativar" persistent max-width="550">
      <v-card class="borda" flat>
        <v-card-title class="headline">
          <v-row>
            <v-col md="auto" sm="auto" cols="auto">
              <span class="black--text">Desativar acesso</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="auto" sm="auto" cols="auto">
              <v-btn icon text @click="closeInativar()">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row class="my-n6">
            <v-col class="mb-n5" cols="12" sm="12" md="12">
              <span class="font-weight-bold black--text">Data de saída *</span>
              <v-menu
                ref="menuInativar"
                v-model="menuInativar"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    solo
                    flat
                    outlined
                    dense
                    @blur="data_saida = parseDate(dateFormattedInativar)"
                    v-model="dateFormattedInativar"
                    append-icon="mdi-calendar"
                    clearable
                    v-mask="data_mask"
                    v-on="on"
                    @input="menu1 = false"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateInativar"
                  no-title
                  locale="pt-br"
                  scrollable
                  @input="menuInativar = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="mr-6">
            <v-spacer></v-spacer>
            <v-btn
              style="
                background-color: #283480 !important;
                color: #00ffd4 !important;
              "
              rounded
              :loading="loadingInativar"
              :disabled="loadingInativar"
              @click="inativarUser()"
              >Desativar</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG PLANO -->
    <v-dialog v-model="dialog_plano" persistent max-width="550">
      <v-card class="borda" flat>
        <v-card-title class="headline">Editar plano</v-card-title>
        <v-card-text>
          <v-col class="mb-n5" cols="12" sm="12" md="12">
            <span class="font-weight-bold black--text">Plano</span>
            <v-select
              label="Selecione"
              no-data-text="Nenhum registro encontrado"
              v-model="edit_plano.plano"
              solo
              dense
              flat
              outlined
              clearable
              :items="planos"
              @change="changePlano()"
              item-value="id_plano_clube"
              item-text="plano_clube_nome"
            ></v-select>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="closeEditPlano()"
            >Cancelar</v-btn
          >
          <v-btn
            style="
              background-color: #283480 !important;
              color: #00ffd4 !important;
            "
            rounded
            :loading="loadingPlano"
            :disabled="loadingPlano"
            @click="editarPlano()"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG RELATÓRIO -->
    <v-dialog persistent v-model="dialog_relatorio" max-width="700" scrollable>
      <v-card flat class="borda" height="500">
        <v-card-title class="my-n5">
          <v-row>
            <v-col md class="mt-2">Relatório</v-col>
            <v-spacer></v-spacer>
            <v-col md="auto">
              <v-btn icon text @click="dialog_relatorio = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-tabs grow centered color="#283480" center-active fixed>
            <v-tab>
              <v-icon left>mdi-clipboard-account-outline</v-icon>Movimentação de
              associados
            </v-tab>
            <v-tab>
              <v-icon left>mdi-account-details</v-icon>Associados detalhado
            </v-tab>
            <v-tab>
              <v-icon left>mdi-account-cash-outline</v-icon>Extrato Associado
            </v-tab>
            <!-- TAB #1 -->
            <v-tab-item>
              <v-row>
                <v-col md="12">
                  <span class="font-weight-bold black--text">Período:</span>
                  <VueCtkDateTimePicker
                    class="date-picker"
                    locale="pt-BR"
                    aria-label="Período"
                    v-model="relatorio"
                    :no-header="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    :label="'Período'"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :auto-close="true"
                    :noClearButton="true"
                    :no-label="true"
                    :shortcut="'last30Days'"
                  ></VueCtkDateTimePicker>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-btn
                  rounded
                  color="#283480"
                  class="white--text ml-n3 mb-5"
                  :loading="loading"
                  :disabled="loading"
                  @click="getRelatorio()"
                  >Gerar</v-btn
                >
              </v-row>
            </v-tab-item>

            <!-- TAB #2 -->
            <v-tab-item>
              <v-row>
                <v-col>
                  <span class="font-weight-bold black--text">Período:</span>
                  <VueCtkDateTimePicker
                    class="date-picker"
                    locale="pt-BR"
                    aria-label="Período"
                    v-model="relatorioDetalhado"
                    :no-header="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    :label="'Período'"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :auto-close="true"
                    :noClearButton="true"
                    :no-label="true"
                    :shortcut="'last30Days'"
                  ></VueCtkDateTimePicker>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-n2 mb-n6">
                  <v-checkbox
                    class="pa-0 ma-0"
                    value="1"
                    v-model="relatorioDetalhado.data_associacao"
                    label="Buscar por data de associação"
                    color="#283480"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text"
                    >Grupo Familiar</span
                  >
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhum grupo familiar cadastrado"
                    v-model="relatorioDetalhado.familia"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    item-color="#283480"
                    outlined
                    clearable
                    item-text="grupo_familiar_descricao"
                    item-value="id_grupo_familiar"
                    :items="grupos_familiares"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.grupo_familiar_descricao }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{
                          relatorioDetalhado.familia.length - 1
                        }}
                        outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text">Planos</span>
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhum plano cadastrado"
                    v-model="relatorioDetalhado.plano"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    item-color="#283480"
                    outlined
                    clearable
                    item-text="plano_clube_nome"
                    item-value="id_plano_clube"
                    :items="planos"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.plano_clube_nome }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{
                          relatorioDetalhado.planos.length - 1
                        }}
                        outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-btn
                  rounded
                  color="#283480"
                  class="white--text ml-n3 mb-5"
                  :loading="loading"
                  :disabled="loading"
                  @click="getRelatorioDetalhado()"
                  >Gerar</v-btn
                >
              </v-row>
            </v-tab-item>

            <!-- TAB #3 -->
            <v-tab-item>
              <v-row>
                <v-col md="12">
                  <span class="font-weight-bold black--text">Período:</span>
                  <VueCtkDateTimePicker
                    class="date-picker"
                    locale="pt-BR"
                    aria-label="Período"
                    v-model="relatorioExtrato"
                    :no-header="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    :label="'Período'"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :auto-close="true"
                    :noClearButton="true"
                    :no-label="true"
                    :shortcut="'last30Days'"
                  ></VueCtkDateTimePicker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text">Contas</span>
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhuma conta cadastrado"
                    v-model="relatorioExtrato.conta"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    item-color="#283480"
                    outlined
                    clearable
                    :items="contas"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ relatorioExtrato.conta.length - 1 }} outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text">Associados</span>
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhum associado cadastrado"
                    v-model="relatorioExtrato.usuario"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    item-color="#283480"
                    outlined
                    clearable
                    item-text="usuario_nome"
                    item-value="id_usuario"
                    :items="formData"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.usuario_nome }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{
                          relatorioExtrato.usuario.length - 1
                        }}
                        outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn
                  rounded
                  color="#283480"
                  class="white--text ml-n3 mb-5"
                  :loading="loading"
                  :disabled="loading"
                  @click="getRelatorioExtrato()"
                  >Gerar</v-btn
                >
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG FILTRO -->
    <v-dialog persistent v-model="dialog_filtro" max-width="525" scrollable>
      <v-card class="borda" flat min-height="525">
        <v-card-title class="ma-2">
          Filtro Extrato
          <v-spacer></v-spacer>
          <v-btn icon text @click="dialog_filtro = false">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-row class="mx-4 mt-5">
          <v-col cols="12" sm="12" md="12">
            <VueCtkDateTimePicker
              class="date-picker"
              locale="pt-BR"
              aria-label="Período"
              v-model="filtroExtrato"
              :no-header="true"
              :range="true"
              :formatted="'L'"
              :format="'YYYY-MM-DD'"
              :label="'Período'"
              :custom-shortcuts="labels"
              :no-button="true"
              :auto-close="true"
              :noClearButton="true"
              :no-label="true"
              :shortcut="'last30Days'"
            ></VueCtkDateTimePicker>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn
              rounded
              color="#283480"
              class="white--text ml-3"
              @click="getExtratos()"
              >Filtrar</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG FILTROS -->
    <v-dialog persistent v-model="filter_modal" max-width="500px">
      <v-form ref="form" v-model="valid" @submit.prevent="filtrar()">
        <v-card class="borda" flat>
          <v-card-title class="ma-2">
            Filtros
            <v-spacer></v-spacer>
            <v-btn icon text @click="closeFilterModal(), filtrar()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text">Plano</span>
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhum plano cadastrado"
                    v-model="filtro.planos"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    outlined
                    clearable
                    item-text="plano_clube_nome"
                    item-value="id_plano_clube"
                    :items="planos"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.plano_clube_nome }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filtro.planos.length - 1 }} outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="mb-n5 mt-2">
                  <span class="font-weight-bold black--text">Grupo</span>
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhum grupo cadastrado"
                    v-model="filtro.grupos"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    outlined
                    clearable
                    :items="grupos"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filtro.grupos.length - 1 }} outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text"
                    >Classificação</span
                  >
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhuma classificação cadastrada"
                    v-model="filtro.classificacoes"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    outlined
                    clearable
                    item-text="classificacao_descricao"
                    item-value="id_classificacao"
                    :items="classificacoes"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.classificacao_descricao }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filtro.classificacoes.length - 1 }} outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="mb-n5">
                  <span class="font-weight-bold black--text"
                    >Grupo Familiar</span
                  >
                  <v-select
                    label="Selecione"
                    no-data-text="Nenhum grupo familiar cadastrado"
                    v-model="filtro.grupos_familiares"
                    solo
                    dense
                    multiple
                    flat
                    small-chips
                    outlined
                    clearable
                    item-text="grupo_familiar_descricao"
                    item-value="id_grupo_familiar"
                    :items="grupos_familiares"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.grupo_familiar_descricao }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{
                          filtro.grupos_familiares.length - 1
                        }}
                        outros)</span
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="closeFilterModal()"
                rounded
                style="color: #283480 !important"
                outlined
                >Cancelar</v-btn
              >
              <v-btn
                class="ml-2"
                rounded
                style="
                  background-color: #283480 !important;
                  color: #00ffd4 !important;
                "
                @click="filtrar()"
              >
                <v-icon>mdi-filter</v-icon>
                <span>Filtrar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG DELETE EXTRATO -->
    <v-dialog v-model="dialog_delete_extrato" persistent max-width="650">
      <v-card class="borda" flat>
        <v-card-title class="headline">Excluir lançamento</v-card-title>
        <!-- <v-card-text>Esta ação é irreversível!</v-card-text> -->
        <v-card-text>
          <span class="font-weight-bold black--text">Descrição:</span>
          {{ deleteExtrato.descricao }}
          <br />
          <span class="font-weight-bold black--text">Valor:</span>
          {{ deleteExtrato.valor }}
          <br />
          <span class="font-weight-bold black--text">Data:</span>
          {{ deleteExtrato.data | moment("L") }}
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            rounded
            color="#283480"
            @click="dialog_delete_extrato = false"
            >Cancelar</v-btn
          >
          <v-btn
            style="
              background-color: #283480 !important;
              color: #00ffd4 !important;
            "
            rounded
            :loading="loadingExcluirExtrato"
            :disabled="loadingExcluirExtrato"
            @click="deleteExtratoF()"
            >Excluir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as locais from "../../public/json/cidades.json";
import * as paises from "../../public/json/paises.json";
import { validate } from "gerador-validador-cpf";
import Api from "@/common/api.helper";
import { VueEditor } from "vue2-editor";
import axios from "axios";
import moment from "moment";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
export default {
  components: {
    VueCtkDateTimePicker,
    VueEditor,
  },
  data: () => {
    return {
      relatorioDetalhado: {
        start: moment().subtract(30, "d").format("YYYY-MM-DD"),
        end: new Date().toISOString().substr(0, 10),
        familia: [],
        data_associacao: true,
        plano: [],
      },
      relatorioExtrato: {
        start: moment().subtract(30, "d").format("YYYY-MM-DD"),
        end: new Date().toISOString().substr(0, 10),
        conta: [],
        associado: [],
      },
      editor: {
        customToolbar: [
          ["bold", "italic"],
          [{ header: [false, 1, 2, 3, 4, 5] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "video"],
          ["clean"],
        ],
        style: "font-size:12px!important",
        // content: this.value
      },
      loadingMsg: false,
      nova_mensagem: {
        usuarios: [],
        grupos: [],
        mensagem_titulo: "",
        enviar_todos_associados: false,
        enviar_grupos: false,
        enviar_email: false,
        mensagem_descricao: "",
        fk_id_clube: "",
      },
      loadingExcluirExtrato: false,
      dialog_delete_extrato: false,
      labels: [
        { key: "thisDay", label: "Hoje", value: "day" },
        { key: "last30Days", label: "Últimos 30 dias", value: 30 },
        { key: "thisMonth", label: "Este mês", value: "month" },
        { key: "lastMonth", label: "Mês passado", value: "-month" },
        { key: "thisYear", label: "Este ano", value: "year" },
        { key: "lastYear", label: "Últ. ano", value: "-year" },
      ],
      search: "",
      filter_modal: false,
      dialog_filtro: false,
      loadingExtrato: false,
      categorias: [],
      contas: [],
      menuExtrato: false,
      menuExtratoLancamento: false,
      dateExtrato: "",
      dateExtratoL: "",
      dateFormattedExtrato: "",
      dateFormattedExtratoL: "",
      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: true,
      },
      extrato_tipo: [
        { text: "Débito", value: 1 },
        { text: "Crédito", value: 2 },
      ],
      dialog_novo_extrato: false,
      novo_extrato: {
        asaas_bol: false,
        fluxo_bol: false,
        valor_bruto: 0,
        tipo: null,
        vencimento: "",
        lancamento: "",
        valor: "",
        descricao: "",
        asaas: 0,
        fluxo: 0,
        associado: 0,
        conta: 0,
        categoria: 0,
      },

      menuInativar: false,
      dialog_inativar: false,
      dialog_status: false,
      dialog_vincular: false,
      dialog_vincular_associado: false,
      cpf_valido: true,
      relatorio: {
        start: moment().subtract(30, "d").format("YYYY-MM-DD"),
        end: new Date().toISOString().substr(0, 10),
        relatorio_check: false,
      },
      dateRi: "",
      dateRf: "",
      dateFormattedRi: "",
      dateFormattedRf: "",
      brazil: false,
      loading: "false",
      loadingLancamentos: "false",
      cep_errado: "",
      data_mask: "##/##/####",
      cpf: "###.###.###-##",
      cep: "#####-###",
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Extrato", icon: "mdi-cash-multiple" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" },
      ],
      opcoesStatus: [
        { text: "Pendente", value: 0 },
        { text: "Confirmado", value: 1 },
        { text: "Conciliado", value: 2 },
      ],
      opcoesRemover: [{ nome: "⠀Remover vínculo", icon: "mdi-account-cancel" }],
      opcoesCancelar: [
        { nome: "⠀Cancelar vínculo", icon: "mdi-account-cancel" },
      ],
      opcoes2: [
        { nome: "⠀Editar status", icon: "mdi-pencil-outline" },
        // { nome: "⠀Editar plano", icon: "mdi-file-certificate" },
      ],
      menu1: false,
      data_saida: "",
      dateInativar: "",
      dateFormattedInativar: "",
      date: "",
      dateFormatted: "",
      menuAssociado: false,
      menuAssociado2: false,
      dateAssociado: "",
      dateFormattedAssociado: "",
      menu2: false,
      senha_icone: "mdi-18px mdi-eye",
      senha: "password",
      disable_locais: false,
      dialog_associado: false,
      dialog_extrato: false,
      dialog_delete: false,
      formData: [],
      lancamentos: [],
      perfil: [],
      dialog_remover: false,
      grupos: [],
      perfil_nomes: [],
      novo_associado: {
        usuario_nome: "",
        usuario_imagem: [],
        usuario_imagemNew: [],
        usuario_imagem_delete: 0,
        usuario_email: "",
        usuario_telefone: "",
        usuario_data_nascimento: "",
        usuario_cpf: "",
        usuario_cep: "",
        usuario_rua: "",
        usuario_numero: "",
        usuario_complemento: "",
        usuario_bairro: "",
        usuario_cidade: "",
        usuario_estado: "",
        usuario_pais: "",
        usuario_observacao: "",
        usuario_data_associacao: "",
        fk_id_perfil: "",
        grupo: "",
        plano: "",
        codigo_controle: "",
        fk_id_classificacao: "",
        fk_id_grupo_familiar: "",
      },
      rulesAdicionalEmail: [
        (v) => !!v || "Campo Obrigatório.",
        (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      ],
      cidades: [],
      disable_cpf: false,
      estados: [],
      paises: [],
      planos: [],
      classificacoes: [],
      grupos_familiares: [],
      valid: true,
      requiredRules: [(v) => !!v || "Campo Obrigatório."],
      requiredRulesCPF: [],
      items_per_pag: 10,
      items_per_pag2: 10,
      items_per_pag3: 10,
      items_per_pag4: 10,
      items_per_pag5: 10,
      items_per_pag6: 10,
      cabecalho: [
        { text: "", align: "center", value: "usuario_imagem" },
        { text: "Nome", align: "start", value: "usuario_nome" },
        { text: "E-mail", align: "center", value: "usuario_email" },
        { text: "Data de registro", align: "center", value: "created_at" },
        {
          text: "Classificação",
          align: "center",
          value: "fk_id_classificacao",
        },
        {
          text: "Família",
          align: "center",
          value: "grupo_familiar.grupo_familiar_descricao",
        },
        { text: "Plano", align: "center", value: "plano_nome" },
        { text: "Grupo", align: "center", value: "grupo_nome" },
        { text: "Ações", align: "end", sortable: false, value: "acao" },
      ],
      cabecalhoClubes: [
        { text: "", align: "center", value: "clube_logotipo" },
        {
          text: "Nome comercial",
          align: "start",
          value: "clube_nome_comercial",
        },
        { text: "E-mail", align: "center", value: "clube_email" },
        { text: "Data de registro", align: "center", value: "created_at" },
        { text: "Plano", align: "center", value: "plano" },
        {
          text: "Status",
          align: "center",
          value: "hierarquia_requisicao_status",
        },
        { text: "Ações", align: "end", sortable: false, value: "acao" },
      ],
      cabecalhoDistritoM: [
        { text: "", align: "center", value: "clube_logotipo" },
        {
          text: "Nome comercial",
          align: "start",
          value: "clube_nome_comercial",
        },
        { text: "E-mail", align: "center", value: "clube_email" },
        { text: "Data de registro", align: "center", value: "created_at" },
        {
          text: "Status",
          align: "center",
          value: "hierarquia_requisicao_status",
        },
        { text: "Ações", align: "end", sortable: false, value: "acao" },
      ],
      cabecalhoExtrato: [
        { text: "Data", align: "left", value: "extrato_lancamento" },
        { text: "D", sortable: false, align: "start", value: "extrato_cred" },
        { text: "C", sortable: false, align: "center", value: "extrato_deb" },
        { text: "Desc.", align: "center", value: "extrato_descricao" },
        {
          text: "Venc.",
          align: "center",

          value: "extrato_vencimento",
        },
        {
          text: "Conta",
          align: "center",
          value: "conta_nome",
        },
        {
          text: "Situação",
          align: "end",
          value: "extrato_status",
        },
        {
          text: "Ações",
          align: "end",
          value: "acoes",
        },
      ],
      fechamento_data: "",
      cabecalhoClubesAbaixo: [
        { text: "", align: "center", value: "clube_logotipo" },
        {
          text: "Nome comercial",
          align: "start",
          value: "clube_nome_comercial",
        },
        { text: "E-mail", align: "center", value: "clube_email" },
        { text: "Data de registro", align: "center", value: "created_at" },
        {
          text: "Status",
          align: "center",
          value: "hierarquia_requisicao_status",
        },
        { text: "Ações", align: "end", sortable: false, value: "acao" },
      ],
      requiredAdicional: false,
      rulesAdicional: [],
      rulesAdicionalCPF: [],
      codigo_hierarquia: "",
      codigo_associado: "",
      clube_codigo: [],
      resto: [],
      valido: false,
      loading_vinculo: false,
      loading_sim: false,
      clube_hierarquia: "",
      cod_hierarquia: "",
      listagem: [],
      index_status: 0,
      nome_comercial: "",
      listagemDm: [],
      dialog_relatorio: false,
      id_hierarquia: {
        id_hierarquia_requisicao: "",
      },
      change_status: {
        id_hierarquia_requisicao: "",
        status: "",
        id_clube_origem: "",
      },
      loadingInativar: false,
      editModulo: false,
      dialog_plano: false,
      edit_plano: {
        clube: "",
        plano: "",
      },
      extratoValores: [],
      loadingPlano: false,
      rulesAdicionalCod: [(v) => !!v || "Campo Obrigatório."],
      loadingVincularAssociado: false,
      extratos: [],
      filtroExtrato: {
        start: moment().subtract(30, "d").format("YYYY-MM-DD"),
        end: new Date().toISOString().substr(0, 10),
      },
      filtro: {
        start: moment().subtract(30, "d").format("YYYY-MM-DD"),
        end: new Date().toISOString().substr(0, 10),
        planos_nome: [],
        grupos_nome: [],
        classificacoes_nome: [],
        grupos_familiares_nome: [],
      },
      deleteExtrato: {
        descricao: "",
        valor: "",
        data: "",
        id_extrato: "",
      },
      telefone: "(##) #####-####",
      dialog_mensagens: false,
      msgTo: [],
      msgToGrupos: [],
      dialog_ctz_msg: false,
    };
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted2() {
      return this.formatDate(this.dateAssociado);
    },
    // telefone() {
    //   let telefone = "";
    //   if (this.novo_associado.usuario_telefone) {
    //     if (this.novo_associado.usuario_telefone.length > 14) {
    //       telefone = "(##) # ####-####";
    //     } else {
    //       telefone = "(##) ####-####";
    //     }
    //   }
    //   return telefone;
    // },
    requiredFluxo() {
      let required = "";
      if (this.novo_extrato.fluxo_bol) {
        required = [(v) => !!v || "Campo Obrigatório."];
      } else {
        required = [];
      }
      return required;
    },
  },
  created() {
    this.getHierarquia();
    this.getListagemClubes();
    this.getListagemDM();
    this.getAssociados();
    this.getPerfil();
    this.getGrupo();
    this.getPaises();
    this.getPlanos();
    this.getClassificacoes();
    this.getGruposFamiliares();
    this.validaEdicaoModulo();
    this.getContas();
    this.getCategorias();
    this.getFechamento();
    this.getGrupos();
  },
  methods: {
    getRelatorioExtrato() {
      let rota =
        "?data_inicio=" +
        moment(this.relatorioExtrato.start).format("YYYY-MM-DD") +
        "&data_fim=" +
        moment(this.relatorioExtrato.end).format("YYYY-MM-DD") +
        "&clube=" +
        JSON.parse(localStorage.getItem("clube-atual")).id_clube;
      if (this.relatorioExtrato.conta) {
        rota += "&conta=" + this.relatorioExtrato.conta;
      }
      if (this.relatorioExtrato.usuario) {
        rota += "&usuario=" + this.relatorioExtrato.usuario;
      }
      this.loading = true;
      Api.get("/associados/relatorioExtratoAssociado" + rota)
        .then((response) => {
          let file = response.data.link;
          let link = document.createElement("a");
          link.href = file;
          link.download = "Relatorio_associado_extrato.pdf";
          link.target = "_blank";
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.error("Oops, erro ao gerar relatório!");
          this.loading = false;
          throw err;
        });
    },
    getRelatorioDetalhado() {
      let rota =
        "?data_inicio=" +
        moment(this.relatorioDetalhado.start).format("YYYY-MM-DD") +
        "&data_fim=" +
        moment(this.relatorioDetalhado.end).format("YYYY-MM-DD") +
        "&clube=" +
        JSON.parse(localStorage.getItem("clube-atual")).id_clube +
        "&data_associacao=" +
        this.relatorioDetalhado.data_associacao;
      if (this.relatorioDetalhado.familia) {
        rota += "&familia=" + this.relatorioDetalhado.familia;
      }
      if (this.relatorioDetalhado.plano) {
        rota += "&plano=" + this.relatorioDetalhado.plano;
      }
      this.loading = true;
      Api.get("/associados/relatorioAssociadosDetalhado" + rota)
        .then((response) => {
          let file = response.data.link;
          let link = document.createElement("a");
          link.href = file;
          link.download = "Relatorio_associado_detalhado.pdf";
          link.target = "_blank";
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.error("Oops, erro ao gerar relatório!");
          this.loading = false;
          throw err;
        });
    },
    ctzMsg() {
      if (this.$refs.formMsg.validate()) {
        this.dialog_ctz_msg = true;
      }
    },
    changeAssociados() {
      if (this.nova_mensagem.enviar_todos_associados == true) {
        this.nova_mensagem.usuarios = [];
        for (let i = 0; i < this.msgTo.length; i++) {
          this.nova_mensagem.usuarios.push(this.msgTo[i].value);
        }
      } else {
        this.nova_mensagem.usuarios = [];
      }
    },
    changeGrupos() {
      this.nova_mensagem.enviar_todos_associados = false;
      this.nova_mensagem.grupos = [];
      this.nova_mensagem.usuarios = [];
    },
    close_msg() {
      this.nova_mensagem = {
        usuarios: [],
        grupos: [],
        mensagem_titulo: "",
        enviar_todos_associados: false,
        enviar_grupos: false,
        enviar_email: false,
        mensagem_descricao: "",
        fk_id_clube: "",
      };
      this.dialog_mensagens = false;
      this.dialog_ctz_msg = false;
      this.$refs.formMsg.resetValidation();
    },
    mensagens() {
      if (
        this.nova_mensagem.usuarios.length <= 0 &&
        this.nova_mensagem.grupos.length <= 0
      ) {
        this.$toast.info(
          "Selecione pelo menos um Associado ou Grupo para enviar a Mensagem"
        );
      } else {
        if (this.$refs.formMsg.validate()) {
          this.loadingMsg = true;
          this.nova_mensagem.fk_id_clube = JSON.parse(
            localStorage.getItem("clube-atual")
          ).id_clube;
          Api.post(`/associados/mensagens`, this.nova_mensagem)
            .then((response) => {
              if (response.data.success) {
                if (this.nova_mensagem.enviar_email == true) {
                  this.mensagemComEmail();
                }
                this.$toast.success(response.data.success);
              } else {
                this.$toast.error(response.data.errors);
              }
              this.loadingMsg = false;
              this.close_msg();
            })
            .catch((err) => {
              this.loadingMsg = false;
              throw err;
            });
        }
      }
    },
    mensagemComEmail() {
      Api.post(`/associados/mensagens/email`, this.nova_mensagem)
        .then((response) => {
          if (response.data.success) {
            this.$toast.success(response.data.success);
          } else {
            this.$toast.error(response.data.errors);
          }
        })
        .catch((err) => {
          this.loadingMsg = false;
          throw err;
        });
    },
    imgAWS(item) {
      if (item.usuario_imagem) {
        if (item.usuario_imagem.indexOf("amazonaws.com/") != -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    getGrupos() {
      Api.get(`/grupos`)
        .then((response) => {
          if (response) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.msgToGrupos.push({
                text: response.data.data[i].grupo_nome,
                value: response.data.data[i].id_grupo,
              });
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteExtratoF() {
      this.loadingExcluirExtrato = true;
      Api.delete(`/associados/extrato/` + this.deleteExtrato.id_extrato)
        .then((response) => {
          if (response.data.errors) {
            this.$toast.error(response.data.errors);
            this.loadingExcluirExtrato = false;
            this.dialog_delete_extrato = false;
          } else {
            this.$toast.success("Extrato excluído com sucesso!");
            this.getExtratos();
            this.dialog_delete_extrato = false;
            this.loadingExcluirExtrato = false;
          }
        })
        .catch((err) => {
          this.dialog_delete_extrato = false;
          this.loadingExcluirExtrato = false;
          throw err;
        });
    },
    acaoExtrato(acao, item) {
      if (acao == "Editar") {
        this.dateExtrato = item.extrato_vencimento;
        this.dateFormattedExtrato = this.formatDate(item.extrato_vencimento);
        this.dateExtratoL = item.extrato_lancamento;
        this.dateFormattedExtratoL = this.formatDate(item.extrato_lancamento);
        this.novo_extrato = {
          asaas_bol: false,
          fluxo_bol: false,
          valor_bruto: this.floatToMoney(item.extrato_valor),
          tipo: item.extrato_tipo,
          vencimento: item.extrato_vencimento,
          lancamento: item.extrato_lancamento,
          valor: item.extrato_valor,
          descricao: item.extrato_descricao,
          asaas: 0,
          fluxo: 0,
          associado: item.fk_id_usuario,
          conta: item.fk_id_conta,
          categoria: item.fk_id_categoria,
          extrato_status: item.extrato_status,
          id_extrato: item.id_extrato,
        };
        this.dialog_novo_extrato = true;
      }
      if (acao == "Excluir") {
        this.deleteExtrato = {
          descricao: item.extrato_descricao,
          valor: this.floatToMoney2(item.extrato_valor),
          data: item.extrato_lancamento,
          id_extrato: item.id_extrato,
        };
        this.dialog_delete_extrato = true;
      }
    },
    closeFilterModal() {
      this.filter_modal = false;
    },
    saldoExtrato(saldo) {
      let res = 0;
      if (saldo == 1) {
        res = this.extratoValores.saldo_anterior;
      }
      if (saldo == 2) {
        res = this.extratoValores.saldo_periodo;
      }
      if (saldo == 3) {
        res = this.extratoValores.saldo_conciliado;
      }
      if (saldo == 4) {
        res = this.extratoValores.saldo_provisionado;
      }
      return this.floatToMoney2(res);
    },
    getExtratos() {
      let filtro =
        "?associado=" +
        this.formData.id_usuario +
        "&data_inicial=" +
        this.filtroExtrato.start +
        "&data_final=" +
        this.filtroExtrato.end;

      Api.get(`/associados/extrato/` + filtro)
        .then((response) => {
          if (response.data) {
            this.extratos = response.data.items;
            this.extratoValores = response.data;
            this.dialog_filtro = false;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    floatToMoney(money) {
      money = money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
      let res = money.substr(3);
      return res;
    },
    floatToMoney2(money) {
      if (!money) {
        return "R$ 0,00";
      }
      money = money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });

      return money;
    },
    close_extrato() {
      this.dialog_novo_extrato = false;
      this.dateFormattedExtrato = "";
      this.dateExtrato = "";
      this.dateExtratoL = "";
      this.novo_extrato = {
        asaas_bol: false,
        fluxo_bol: false,
        tipo: null,
        vencimento: "",
        lancamento: "",
        valor: "",
        descricao: "",
        asaas: 0,
        fluxo: 0,
        associado: 0,
        conta: 0,
        categoria: 0,
      };
      this.$refs.form.resetValidation();
    },
    moneyToFloat(money) {
      if (!money || !money.length) {
        return false;
      }

      if (money.indexOf("R$") != -1) {
        money = money.split("R$")[1];
      }

      let toFloatNumber = "";

      for (let letter of money) {
        if (letter !== "." && letter !== ",") {
          toFloatNumber += letter;
        }
      }

      let integerNumbers = "";
      for (let letter of toFloatNumber.substr(0, toFloatNumber.length - 2)) {
        if (letter !== " ") {
          integerNumbers += letter;
        }
      }

      let decimalNumbers = toFloatNumber.substr(
        toFloatNumber.length - 2,
        toFloatNumber.length
      );

      return parseFloat(`${integerNumbers}.${decimalNumbers}`);
    },
    postExtrato() {
      this.loadingExtrato = true;
      if (this.$refs.form.validate()) {
        if (this.novo_extrato.tipo == 1) {
          this.novo_extrato.fluxo = this.novo_extrato.fluxo_bol == true ? 1 : 0;
          this.novo_extrato.asaas = this.novo_extrato.asaas_bol == true ? 1 : 0;
        } else if (this.novo_extrato.tipo == 2) {
          this.novo_extrato.asaas = 0;
          this.novo_extrato.fluxo = this.novo_extrato.fluxo_bol == true ? 1 : 0;
        }
        this.novo_extrato.associado = this.formData.id_usuario;
        this.novo_extrato.valor = this.moneyToFloat(
          this.novo_extrato.valor_bruto
        );
        let edit = "";
        if (this.novo_extrato.id_extrato) {
          edit = "/" + this.novo_extrato.id_extrato;
        }
        Api.post(`/associados/extrato/cadastrar` + edit, this.novo_extrato)
          .then((response) => {
            if (response) {
              this.$toast.success(response.data.success);
            }
            this.close_extrato();
            this.getExtratos();
            this.loadingExtrato = false;
          })
          .catch((err) => {
            this.close_extrato();
            this.loadingExtrato = false;
            throw err;
          });
      } else {
        this.loadingExtrato = false;
      }
    },
    fluxo1() {
      if (this.novo_extrato.tipo == 2) {
        this.novo_extrato.asaas = 0;
      }
    },
    getContas() {
      Api.get(`/contas/todas`)
        .then((response) => {
          if (response.data.data) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.contas.push({
                text: response.data.data[i].conta_nome,
                value: response.data.data[i].id_conta,
              });
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getCategorias() {
      Api.get(`/categorias-lancamentos`)
        .then((response) => {
          if (response.data.data) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.categorias.push({
                text: response.data.data[i].categoria_nome,
                value: response.data.data[i].id_categoria,
              });
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    idClassificacao(item) {
      for (let i = 0; i < this.classificacoes.length; i++) {
        if (
          this.classificacoes[i].id_classificacao == item.fk_id_classificacao
        ) {
          return this.classificacoes[i].classificacao_descricao;
        }
      }
    },
    idGrupoFamiliar(item) {
      for (let i = 0; i < this.grupos_familiares.length; i++) {
        if (
          this.grupos_familiares[i].id_grupo_familiar ==
          item.fk_id_grupo_familiar
        ) {
          return this.grupos_familiares[i].grupo_familiar_descricao;
        }
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    reset_status() {
      this.dialog_status = false;
      this.change_status = {
        id_hierarquia_requisicao: "",
        status: "",
        id_clube_origem: "",
      };
    },
    setStatus(v) {
      this.change_status.status = v;
      Api.post("/associados/altera-requisicoes", this.change_status)
        .then((response) => {
          if (!response.data.errors) {
            this.$toast.success("Status alterado com sucesso!");
            this.getListagemClubes();
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
      this.reset_status();
    },
    menu_status(opcao, item) {
      // "⠀Remover vínculo"
      // "⠀Cancelar vínculo"
      // "⠀Editar status"
      if (opcao.nome == "⠀Editar status") {
        this.nome_comercial = item.clube_nome_comercial;
        this.dialog_status = true;
        this.change_status = {
          id_hierarquia_requisicao: item.id_hierarquia_requisicao,
          status: "",
          id_clube_origem: item.id_clube_origem,
        };
      } else if (
        opcao.nome == "⠀Cancelar vínculo" ||
        opcao.nome == "⠀Remover vínculo"
      ) {
        this.dialog_remover = true;
        this.id_hierarquia = {
          id_hierarquia_requisicao: item.id_hierarquia_requisicao,
          nome: item.clube_nome_comercial,
        };
      } // else if (opcao.nome == "⠀Editar plano") {
      //   this.dialog_plano = true;
      //   this.edit_plano = {
      //     clube: item.id_clube,
      //     plano: item.id_plano_clube ? item.id_plano_clube : "",
      //   };
      // }
    },
    deleteVinculo() {
      Api.post("/associados/remove-requisicoes", this.id_hierarquia)
        .then((response) => {
          if (!response.data.errors) {
            this.$toast.success("Vínculo removido com sucesso!");
            this.getListagemClubes();
            this.getListagemDM();
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch((err) => {
          ///this.$toast.error(err.response.data);
          throw err;
        });
      this.dialog_remover = false;
    },
    getListagemClubes() {
      let req = "";
      if (this.clube_hierarquia == 1) {
        req = "?hierarquia=1";
      } else {
        req = "";
      }
      Api.get("/associados/lista-requisicoes" + req)
        .then((response) => {
          if (!response.data.errors) {
            this.listagem = response.data;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    getListagemDM() {
      Api.get("/associados/lista-requisicoes?hierarquia=1")
        .then((response) => {
          if (!response.data.errors) {
            this.listagemDm = response.data;
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    getHierarquia() {
      if (localStorage.getItem("clube-atual")) {
        this.clube_hierarquia = JSON.parse(
          localStorage.getItem("clube-atual")
        ).clube_hierarquia;
        this.cod_hierarquia = JSON.parse(
          localStorage.getItem("clube-atual")
        ).clube_codigo_hierarquia;
      }
    },
    confirmar_vinculo() {
      this.loading_sim = true;
      Api.get(
        "/associados/valida-codigo-hierarquia/" +
          this.codigo_hierarquia +
          "?request=1"
      )
        .then((response) => {
          if (!response.data.errors) {
            this.$toast.success("Vínculo realizado com sucesso");
            this.getListagemDM();
            this.close_vincular();
            this.getListagemClubes();
          } else {
            this.close_vincular();
            this.$toast.warning(response.data.errors);
          }
        })
        .catch((err) => {
          this.close_vincular();
          this.$toast.error(err.response.data.errors);
          throw err;
        });
      this.loading_sim = false;
    },
    close_vincular() {
      this.dialog_vincular = false;
      this.dialog_vincular_associado = false;
      this.clube_codigo = [];
      this.valido = false;
      this.codigo_hierarquia = "";
      this.codigo_associado = "";
      this.loadingVincularAssociado = false;
      if (this.$refs.formCodAssociado) {
        this.$refs.formCodAssociado.resetValidation();
      }
    },
    editarPlano() {
      this.loadingPlano = true;
      Api.post("/associados/altera-dados-clube-para-clube/", this.edit_plano)
        .then((response) => {
          if (!response.data.errors) {
            this.$toast.success("Plano editado com sucesso");
            this.getListagemDM();
            this.getListagemClubes();
          } else {
            this.$toast.warning(response.data.errors);
          }
          this.closeEditPlano();
        })
        .catch((err) => {
          this.loadingPlano = false;
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    closeEditPlano() {
      this.dialog_plano = false;
      this.edit_plano = {
        clube: "",
        plano: "",
      };
      this.loadingPlano = false;
    },
    validar_codigo() {
      // DP355V41
      this.loading_vinculo = true;
      if (this.$refs.formCod.validate()) {
        Api.get(
          "/associados/valida-codigo-hierarquia/" + this.codigo_hierarquia
        )
          .then((response) => {
            if (!response.data.errors) {
              this.clube_codigo = response.data;
              this.valido = true;
              this.$toast.success("Código válido");
            } else {
              this.valido = false;
              this.$toast.warning(response.data.errors);
            }
          })
          .catch((err) => {
            this.$toast.error(err.response.data.errors);
            this.valido = false;
            throw err;
          });
      }
      this.loading_vinculo = false;
    },
    verificar_cpf() {
      if (!this.requiredAdicional) {
        if (this.novo_associado.usuario_cpf.length > 0) {
          this.rulesAdicionalCPF = [(v) => validate(v) || "CPF inválido"];
        } else {
          this.rulesAdicionalCPF = [];
        }
      }
    },
    getPaises() {
      for (let i = 0; i < paises.default.length; i++) {
        this.paises.push({
          text: paises.default[i].nome_pais + ", " + paises.default[i].sigla,
          value: paises.default[i].nome_pais,
        });
      }
      this.getEstados();
    },

    getEstados() {
      if (this.novo_associado.usuario_pais == "Brasil") {
        this.brazil = true;
        for (let i = 0; i < locais.default.estados.length; i++) {
          this.estados.push({
            text: locais.default.estados[i].nome,
            value: locais.default.estados[i].nome,
          });
        }
        this.getCidades();
      } else {
        this.brazil = false;
      }
    },

    getCidades() {
      this.brazil2 = false;
      if (this.novo_associado.usuario_pais == "Brasil") {
        this.brazil2 = true;
        this.cidades = [];
        for (let i = 0; i < locais.default.estados.length; i++) {
          if (
            this.novo_associado.usuario_estado ===
            locais.default.estados[i].nome
          ) {
            for (let j = 0; j < locais.default.estados[i].cidades.length; j++) {
              this.cidades[j] = locais.default.estados[i].cidades[j];
            }
          }
        }
      }
    },

    viaCep() {
      if (this.novo_associado.usuario_cep) {
        if (this.novo_associado.usuario_cep.length != 9) {
          this.brazil = true;
          this.disable_locais = false;
        } else {
          axios
            .get(
              "https://viacep.com.br/ws/" +
                this.novo_associado.usuario_cep +
                "/json"
            )
            .then((response) => {
              if (response.data.erro == true) {
                this.cep_errado = "CEP não encontrado";
                this.brazil = true;
                this.disable_locais = false;
              } else {
                this.brazil = false;
                this.disable_locais = true;

                this.novo_associado.usuario_rua = response.data.logradouro;
                this.novo_associado.usuario_cidade = response.data.localidade;
                this.novo_associado.usuario_bairro = response.data.bairro;
                this.novo_associado.usuario_estado = response.data.uf;
                this.novo_associado.usuario_pais = "Brasil";
                this.cep_errado = "";
                for (let i = 0; i < locais.default.estados.length; i++) {
                  if (response.data.uf === locais.default.estados[i].sigla) {
                    this.novo_associado.usuario_estado =
                      locais.default.estados[i].nome;
                  }
                }
              }
            });
        }
      }
    },

    deleteItem() {
      if (this.formData.length <= 1) {
        this.$toast.warning("Não é possível excluir todos os associados");
      } else {
        this.loading = true;
        Api.delete(`/associados/deleteUser/` + this.formData.id_usuario)
          .then((response) => {
            if (response.data.errors) {
              this.$toast.error(response.data.errors);
              this.loading = false;
            } else {
              this.formData.id_usuario = "";
              this.getAssociados();
              this.loading = false;
              this.resto = response.data;
            }
          })
          .catch((err) => {
            this.loading = false;
            throw err;
          });
      }
    },
    getFechamento() {
      Api.get("/fechamento/ultimo")
        .then((response) => {
          if (response) {
            this.fechamento_data = moment(response.data.fechamento_data)
              .add(1, "days")
              .format("YYYY-MM-DD");
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },
    menu(nome, item) {
      this.formData.id_usuario = item.id_usuario;
      if (nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (nome === "⠀Editar") {
        this.date = item.usuario_data_nascimento;
        this.dateAssociado = item.usuario_data_associacao;
        this.dateFormattedAssociado = this.formatDate(
          item.usuario_data_associacao
        );
        this.novo_associado = {
          id_usuario: item.id_usuario,
          usuario_nome: item.usuario_nome,
          usuario_id: item.id_usuario,
          usuario_imagem: item.usuario_imagem,
          usuario_email: item.usuario_email,
          usuario_telefone: item.usuario_telefone,
          usuario_data_nascimento: item.usuario_data_nascimento,
          usuario_cpf: item.usuario_cpf,
          usuario_cep: item.usuario_cep,
          usuario_rua: item.usuario_rua,
          usuario_numero: item.usuario_numero,
          usuario_complemento: item.usuario_complemento,
          usuario_bairro: item.usuario_bairro,
          usuario_cidade: item.usuario_cidade,
          usuario_estado: item.usuario_estado,
          usuario_pais: item.usuario_pais,
          fk_id_perfil: item.fk_id_perfil,
          usuario_data_associacao: item.usuario_data_associacao,
          usuario_observacao: item.usuario_observacao,
          grupo: item.grupo ? item.grupo.id_grupo : "",
          plano: item.plano ? item.plano.id_plano_clube : "",
          codigo_controle: item.codigo_controle,
          fk_id_classificacao: item.fk_id_classificacao,
          fk_id_grupo_familiar: item.fk_id_grupo_familiar,
        };
        this.dialog_associado = true;
        this.changePlano();
      } else if (nome === "⠀Extrato") {
        this.getExtratos();
        this.dialog_extrato = true;
        // this.getLancamentos();
      } else if (nome === "⠀Inativar") {
        this.dialog_inativar = true;
      } else if (nome === "⠀Ativar") {
        let post = {
          data_saida: "",
          ativar: 1,
          clube_token: localStorage.getItem("token"),
        };
        Api.post("/associados/inativar/" + this.formData.id_usuario, post)
          .then((response) => {
            this.loading = false;
            if (!response.data.errors) {
              this.$toast.success(response.data.success);
            } else {
              this.$toast.warning(response.data.errors);
            }
            this.closeInativar();
            this.getAssociados();
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error(err.response.data.errors);
            throw err;
          });
      }
    },
    closeInativar() {
      this.data_saida = "";
      this.dateInativar = "";
      this.dateFormattedInativar = "";
      this.dialog_inativar = false;
    },
    inativarUser() {
      this.loadingInativar = true;
      let data = this.data_saida;
      if (!data) {
        this.$toast.warning("Data de saída obrigatória");
        return;
      }
      let post = {
        data_saida: data,
        clube_token: localStorage.getItem("token"),
      };
      Api.post("/associados/inativar/" + this.formData.id_usuario, post)
        .then((response) => {
          this.loading = false;
          if (!response.data.errors) {
            this.$toast.success(response.data.success);
          } else {
            this.$toast.warning(response.data.errors);
          }
          this.loadingInativar = false;
          this.closeInativar();
          this.getAssociados();
        })
        .catch((err) => {
          this.loadingInativar = false;
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },

    save() {
      this.loading = true;
      this.cep_errado = "";
      if (this.$refs.form.validate()) {
        let formData = new FormData();
        Object.keys(this.novo_associado).map((key) => {
          if (key === "usuario_imagem") {
            let file = this.novo_associado.usuario_imagem;
            if (this.novo_associado.usuario_imagem) {
              if (this.novo_associado.usuario_imagem.name) {
                formData.append(
                  `usuario_imagem`,
                  file,
                  `${new Date().getTime()}.${this.getExtension(
                    this.novo_associado.usuario_imagem.name
                  )}`
                );
              }
            }
          } else {
            if (this.novo_associado[key]) {
              formData.append(key, this.novo_associado[key]);
            }
          }
        });

        let rota = "";
        if (this.novo_associado.id_usuario) {
          rota = "/update/" + this.novo_associado.id_usuario;
        } else {
          rota = "/store";
        }
        Api.post("/associados" + rota, formData)
          .then((response) => {
            this.loading = false;
            if (!response.data.errors) {
              if (this.novo_associado.id_usuario) {
                this.$toast.success("Editado com sucesso!");
              } else {
                this.$toast.success("Cadastrado com sucesso!");
              }
              this.getAssociados();
              this.$refs.form.resetValidation();
              this.close();
            } else {
              this.$toast.warning(response.data.errors);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error(err.data.errors);
            throw err;
          });
      } else {
        this.loading = false;
      }
    },

    getPerfil() {
      Api.get(`/associados/perfis-usuarios`)
        .then((response) => {
          if (response.data.data) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.perfil.push({
                text: response.data.data[i].perfil_nome,
                value: response.data.data[i].id_perfil,
              });
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    getGrupo() {
      Api.get(`/grupos`)
        .then((response) => {
          if (response.data.data) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.grupos.push({
                text: response.data.data[i].grupo_nome,
                value: response.data.data[i].id_grupo,
              });
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    getAssociados() {
      this.loading = true;
      let filtro = "?filtros=";
      var self = this;
      if (this.filtro.planos) {
        filtro = filtro + "&planos=" + this.filtro.planos;
        this.filtro.planos_nome = [];
        this.filtro.planos.forEach((element) => {
          self.planos.forEach((element2) => {
            if (element == element2.id_plano_clube) {
              self.filtro.planos_nome.push(element2.plano_clube_nome);
            }
          });
        });
      }
      if (this.filtro.grupos) {
        filtro = filtro + "&grupos=" + this.filtro.grupos;
        this.filtro.grupos_nome = [];
        this.filtro.grupos.forEach((element) => {
          self.grupos.forEach((element2) => {
            if (element == element2.value) {
              self.filtro.grupos_nome.push(element2.text);
            }
          });
        });
      }
      if (this.filtro.classificacoes) {
        filtro = filtro + "&classificacoes=" + this.filtro.classificacoes;
        this.filtro.classificacoes_nome = [];
        this.filtro.classificacoes.forEach((element) => {
          self.classificacoes.forEach((element2) => {
            if (element == element2.id_classificacao) {
              self.filtro.classificacoes_nome.push(
                element2.classificacao_descricao
              );
            }
          });
        });
      }
      if (this.filtro.grupos_familiares) {
        filtro = filtro + "&grupos_familiares=" + this.filtro.grupos_familiares;
        this.filtro.grupos_familiares_nome = [];
        this.filtro.grupos_familiares.forEach((element) => {
          self.grupos_familiares.forEach((element2) => {
            if (element == element2.id_grupo_familiar) {
              self.filtro.grupos_familiares_nome.push(
                element2.grupo_familiar_descricao
              );
            }
          });
        });
      }
      Api.get(`/associados/user` + filtro)
        .then((response) => {
          if (response.data.data) {
            this.formData = response.data.data;
            for (let i = 0; i < response.data.data.length; i++) {
              this.msgTo.push({
                text: response.data.data[i].usuario_nome,
                value: response.data.data[i].id_usuario,
              });
            }
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },

    filtrar() {
      this.filter_modal = false;
      this.getAssociados();
    },

    // getLancamentos() {
    //   this.loadingLancamentos = true;
    //   Api.get(`/lancamentos/usuario/` + this.formData.id_usuario)
    //     .then((response) => {
    //       if (response.data.data) {
    //         this.lancamentos = response.data.data;
    //         this.loadingLancamentos = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.loadingLancamentos = false;
    //       throw err;
    //     });
    // },

    getPlanos() {
      this.loading = true;
      Api.get(`/planos-clubes`)
        .then((response) => {
          if (response.data.data) {
            this.planos = response.data.data;
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },

    carregarMais() {
      if (this.formData.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },
    carregarMais2() {
      if (this.listagem.length > this.items_per_pag2) {
        this.items_per_pag2 += 10;
      }
    },
    carregarMais3() {
      if (this.listagem.length > this.items_per_pag3) {
        this.items_per_pag3 += 10;
      }
    },
    carregarMais4() {
      if (this.listagem.length > this.items_per_pag4) {
        this.items_per_pag4 += 10;
      }
    },
    carregarMais5() {
      if (this.listagemDm.length > this.items_per_pag5) {
        this.items_per_pag5 += 10;
      }
    },
    carregarMais6() {
      if (this.extratos.length > this.items_per_pag6) {
        this.items_per_pag6 += 10;
      }
    },
    getHashUser(item) {
      let url =
        Api.getApUrl() +
        "/associados/imagem/show?img=" +
        item.usuario_imagem_hash;
      return url;
    },
    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.$refs.form2) {
        this.$refs.form2.resetValidation();
      }
      this.dialog_associado = false;
      this.dialog_extrato = false;
      this.date = "";
      this.dateAssociado = "";
      this.dateFormatted = "";
      this.dateFormattedAssociado = "";
      this.novo_associado = {
        usuario_nome: "",
        usuario_imagem: [],
        usuario_imagemNew: [],
        usuario_imagem_delete: 0,
        usuario_email: "",
        usuario_telefone: "",
        usuario_data_nascimento: "",
        usuario_cpf: "",
        usuario_cep: "",
        usuario_rua: "",
        usuario_numero: "",
        usuario_complemento: "",
        usuario_bairro: "",
        usuario_cidade: "",
        usuario_estado: "",
        usuario_pais: "",
        usuario_observacao: "",
        usuario_data_associacao: "",
        fk_id_perfil: "",
        grupo: "",
        plano: "",
        codigo_controle: "",
        fk_id_classificacao: "",
        fk_id_grupo_familiar: "",
      };
    },

    getExtension(path) {
      var basename = path.split(/[\\/]/).pop(),
        pos = basename.lastIndexOf(".");

      if (basename === "" || pos < 1) return "";

      return basename.slice(pos + 1);
    },

    ver_senha() {
      if (this.senha == "password") {
        this.senha = "";
        this.senha_icone = "mdi-18px mdi-eye-off";
      } else {
        this.senha = "password";
        this.senha_icone = "mdi-18px mdi-eye";
      }
    },

    novoAssociado() {
      this.dialog_associado = true;
      this.brazil = true;
    },

    changePlano() {
      this.requiredAdicional = false;
      this.rulesAdicional = [];
      this.rulesAdicionalCPF = [];
      for (var i = 0; i < this.planos.length; i++) {
        if (this.planos[i].id_plano_clube == this.novo_associado.plano) {
          if (
            this.planos[i].plano_clube_metodo_pagamento == 1 ||
            this.planos[i].plano_clube_metodo_pagamento == 3
          ) {
            this.requiredAdicional = true;
            this.rulesAdicional = [(v) => !!v || "Campo Obrigatório."];
            this.rulesAdicionalCPF = [
              (v) => !!v || "Campo Obrigatório.",
              (v) => validate(v) || "CPF inválido",
            ];
          }
        }
      }
    },

    getClassificacoes() {
      Api.get(`/classificacoes`)
        .then((response) => {
          if (response.data.data) {
            this.classificacoes = response.data.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    getGruposFamiliares() {
      Api.get(`/grupos-familiares`)
        .then((response) => {
          if (response.data.data) {
            this.grupos_familiares = response.data.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    },

    verifMenu(iten) {
      if (this.editModulo) {
        return true;
      }
      if (iten.nome == " Editar") {
        return false;
      }
      if (iten.nome == " Excluir") {
        return false;
      }
      return true;
    },
    saveVinculoAssociado() {
      this.loadingVincularAssociado = true;
      if (this.$refs.formCodAssociado.validate()) {
        var dados = {
          id_usuario: this.codigo_associado,
        };
        Api.post("/associados/relacionar-novo/", dados)
          .then((response) => {
            if (!response.data.errors) {
              this.$toast.success("Vínculo realizado com sucesso.");
              this.getAssociados();
              this.close_vincular();
            } else {
              this.$toast.warning(response.data.errors);
              this.loadingVincularAssociado = false;
            }
          })
          .catch((err) => {
            this.$toast.error(err.response.data.errors);
            this.loadingVincularAssociado = false;
            throw err;
          });
      } else {
        this.loadingVincularAssociado = false;
      }
    },
    getRelatorio() {
      let rota =
        "?data_inicial=" +
        moment(this.relatorio.start).format("YYYY-MM-DD") +
        "&data_final=" +
        moment(this.relatorio.end).format("YYYY-MM-DD");
      this.loading = true;

      Api.get("/associados/relatorioAssociados" + rota)
        .then((response) => {
          let file = response.data.link;
          let link = document.createElement("a");
          link.href = file;
          link.download = "Relatorio_associados.pdf";
          link.target = "_blank";
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.error("Oops, erro ao gerar relatório!");
          this.loading = false;
          throw err;
        });
    },
  },
  watch: {
    menu2(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.novo_associado.usuario_data_nascimento = this.parseDate(
        this.dateFormatted
      );
    },
    dateExtrato() {
      this.dateFormattedExtrato = this.formatDate(this.dateExtrato);
      this.novo_extrato.vencimento = this.parseDate(this.dateFormattedExtrato);
    },
    dateExtratoL() {
      this.dateFormattedExtratoL = this.formatDate(this.dateExtratoL);
      this.novo_extrato.lancamento = this.parseDate(this.dateFormattedExtratoL);
    },
    dateRi() {
      this.dateFormattedRi = this.formatDate(this.dateRi);
      this.relatorio.data_inicial = this.parseDate(this.dateFormattedRi);
    },
    dateRf() {
      this.dateFormattedRf = this.formatDate(this.dateRf);
      this.relatorio.data_final = this.parseDate(this.dateFormattedRf);
    },
    dateInativar() {
      this.dateFormattedInativar = this.formatDate(this.dateInativar);
      this.data_saida = this.parseDate(this.dateFormattedInativar);
    },
    dateAssociado() {
      this.dateFormattedAssociado = this.formatDate(this.dateAssociado);
      this.novo_associado.usuario_data_associacao = this.parseDate(
        this.dateFormattedAssociado
      );
    },
  },
};
</script>